import React from "react";
import { Card, Icon, SemanticICONS } from "semantic-ui-react";
import { IRxComment } from "../../lib/rxMode/IRxComment";
import "./RxOrderComments.css";

const RxOrderComments = ({
  orderComments,
  hideCommentCallback,
  infoBarHeight
}: { orderComments: IRxComment[], hideCommentCallback: (comments: number) => void , infoBarHeight:number}) => {
  if (!orderComments?.length) {
    return null;
  }

  function getOperatorTitle(operatorTitle:string){
    if (operatorTitle != ""){
      return " / " + operatorTitle;
    } else return ""
  }

  const containerHeight= { height: ` calc(100vh - ${infoBarHeight+ 60}px)` };
  var orderCommentCards = orderComments.filter((z: IRxComment, _) => z.visible).map((comment, index) => {
    return (
      <div className="order-comment-card" key={index}>
        <div><b><i>{comment.user}{getOperatorTitle(comment.operatorTitle)}</i></b><Icon size="large" style={{ float: "right" }} name="window close" onClick={() => { hideCommentCallback(index); }} ></Icon><br /><div>
          <div >
            <span dangerouslySetInnerHTML={{ __html:comment.message}} />
            <br />
            <div style={{ float: "right" }}>
              <span style={{ fontSize: "12px" }}>
                {comment.created.toLocaleString()}
              </span>
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
        </div>
        </div>
      </div>
    )
  });

  if (orderCommentCards.length == 0) orderCommentCards = [(<div>
    <span style={{display: "flex", justifyContent: "center", marginTop:"20%"}}>
      Inga kommentarer att visa
    </span>
  </div>)]
  
  return (
    <div style={containerHeight} className={"order-comment-list"}>
      <div className="warning-list flexColumn">
        <Card className="warning-card">
          <Card.Content style={{ minHeight: "200px" }}>
            <Card.Header >Orderkommentarer</Card.Header>
            {orderCommentCards}
          </Card.Content>
        </Card>
      </div>
    </div>
  );
};

export default RxOrderComments;
